import AzPanel from './az-panel.vue';

/* istanbul ignore next */
AzPanel.install = function (Vue) {
  Vue.component(AzPanel.name, AzPanel);
};

export default AzPanel;
